// extracted by mini-css-extract-plugin
export var filterIncDec = "_cq-0";
export var leftBorder = "_cq-1";
export var rightBorder = "_cq-2";
export var stringInput = "_cq-3";